import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

import Pager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import MainTable from './main_table';

import './searchresult.css';
import SearchPager from 'shared_components/search_pager';
import { tablePageSize } from 'modules/blood_bank/settings/address/table/settings';

class AllTable extends React.Component {
	state = {
		// pageSize: GLOBAL_TABLE_PAGE_SIZE,
		pageSize: tablePageSize,
		currentPage: 1,
		isLoading: false,
	};

	componentDidMount() {
		// this.setState({ showLoading: false });
	}

	onChangePageSize = pageSize => {
		this.setState({ pageSize });
	};

	onChangePager = pageSize => {
		this.setState({ pageSize, currentPage: 1 });
	};

	onPageChange = (page) => {
		this.setState({ currentPage: page });
		console.log('onPageChange page =>', page);
	};


	render() {
		const { isLoading, pageSize, currentPage } = this.state;
		const { labResults, onClickTableRow, onClickPrint } = this.props;

		return (
			<div>
				<Row>
					<Col lg={24} xs={24}>
						{/* <Pager
							handleChangeSize={this.onChangePageSize}
							pageTotal={labResults.length}
							pageSize={pageSize}
						/> */}
						<SearchPager
							pageSize={pageSize}
							pageTotal={labResults.length}
							currentPage={currentPage}
							handleChangeSize={this.onChangePager}
						/>
					</Col>
				</Row>
				<div className="space-y-sm"></div>
				<Row>
					<Col lg={24} xs={24}>
						<MainTable
							isLoading={isLoading}
							labResults={labResults}
							pageSize={pageSize}
							onClickTableRow={onClickTableRow}
							onClickPrint={onClickPrint}
							onPageChange={this.onPageChange}
						/>
					</Col>
				</Row>
			</div>
		);
	}
}

AllTable.propTypes = {
	labResults: PropTypes.array.isRequired,
	onClickTableRow: PropTypes.func.isRequired,
	onClickPrint: PropTypes.func.isRequired,
};

export default AllTable;
